<label
  class="control display-flex align-items-center cursor-pointer border-radius-pill"
  [ngClass]="{ 'control--wrapped bg-white shadow': wrapped() }"
>
  <div class="font-weight-700" [ngClass]="wrapped() ? 'color-charcoal t-9@r' : 'color-ash t-11@r'">BOOST</div>
  <div class="toggle" [ngClass]="wrapped() ? 'ml-2' : 'ml-1'">
    <input
      #checkbox
      type="checkbox"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onValueChange(checkbox.checked)"
    />
    <div class="switch display-flex align-items-center justify-content-center color-white toggle-switch">
      <sb-icon class="color-yellow" [name]="'flash'" [size]="'6'" />
    </div>
    <div class="toggle-track bg-yellow"></div>
  </div>
</label>
